// VERDICT LIST
export const START_FETCHING_COMPLIANCE_VERDICTS = 'START_FETCHING_COMPLIANCE_VERDICTS';
export const GET_COMPLIANCE_VERDICTS_SUCCESS = 'GET_COMPLIANCE_VERDICTS_SUCCESS';
export const GET_COMPLIANCE_VERDICTS_ERROR = 'GET_COMPLIANCE_VERDICTS_ERROR';

// WRITES
export const START_SAVING_COMPLIANCE_VERDICT = 'START_SAVING_COMPLIANCE_VERDICT';
export const SAVE_COMPLIANCE_VERDICT_SUCCESS = 'SAVE_COMPLIANCE_VERDICT_SUCCESS';
export const SAVE_COMPLIANCE_VERDICT_ERROR = 'SAVE_COMPLIANCE_VERDICT_ERROR';

/*
 * A write abandoned by the page unmounting. Distinct from an error because nothing is reported to
 * the operator - but the flags still have to come down, since this slice outlives the route.
 */
export const SAVE_COMPLIANCE_VERDICT_ABORTED = 'SAVE_COMPLIANCE_VERDICT_ABORTED';

// MODALS
export const SHOW_COMPLIANCE_VERDICT_FORM_MODAL = 'SHOW_COMPLIANCE_VERDICT_FORM_MODAL';
export const HIDE_COMPLIANCE_VERDICT_FORM_MODAL = 'HIDE_COMPLIANCE_VERDICT_FORM_MODAL';
export const SHOW_COMPLIANCE_VERDICT_GRANT_MODAL = 'SHOW_COMPLIANCE_VERDICT_GRANT_MODAL';
export const HIDE_COMPLIANCE_VERDICT_GRANT_MODAL = 'HIDE_COMPLIANCE_VERDICT_GRANT_MODAL';
export const SHOW_COMPLIANCE_VERDICT_REVOKE_MODAL = 'SHOW_COMPLIANCE_VERDICT_REVOKE_MODAL';
export const HIDE_COMPLIANCE_VERDICT_REVOKE_MODAL = 'HIDE_COMPLIANCE_VERDICT_REVOKE_MODAL';
